import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import "./ValiDate.scss";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  requestGstOtpAction,
  resetGstModuleError,
  resetGstOtpError,
  resetGstOtpFetching,
  resetGstOtpMessage,
  resetGstOtpRequestFetching,
  resetGstOtpVerifyError,
  resetGstOtpVerifyFetching,
  resetGstOtpVerifyMessage,
  verifyGstOtpAction,
} from "../../../redux/gstModule";
import {
  RequestGstOtpPayloadType,
  VerifyGstOtpPayloadType,
} from "../../../commonTypes/gstTypes";
import { Warning } from "../../../assets/images";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Loader";
type OtpDataType = {
  client_code: number | null;
  gst_username: string;
  gst_number: string;
};
type AppProps = {
  history: any;
  token: string | null;
  clientCode: number | null;
  gstDetails: any;
  dispatchRequestGstOtp: (data: RequestGstOtpPayloadType) => void;
  gstOtpError: null | string;
  gstOtpVerifyMessage: null | string;
  gstOtpVerifyError: null | string;
  gstOtpVerifyStatusCode: number | null;
  dispatchResetGstError: () => void;
  dispatchResetGstOtpError: () => void;
  fetching: boolean;
  gstOtpMessage: null | string;
  error: null | string | undefined;
  message: null | string;
  dispatchVerifyGstOtp: (data: VerifyGstOtpPayloadType) => void;
  dispatchResetGstOtpMessage: () => void;
  gstOtpFetching: boolean;
  gstOtpVerifyFetching: boolean;
  gstOtpRequestFetching: boolean;
  dispatchResetGstOtpVerifyError: () => void;
  dispatchResetGstOtpVerifyMessage: () => void;
  dispatchResetGstOtpFetching: () => void;
  dispatchResetGstOtpVerifyFetching: () => void;
  dispatchResetGstOtpRequestFetching: () => void;
};

const ValidateGST = ({
  clientCode,
  gstDetails,
  dispatchRequestGstOtp,
  token,
  gstOtpError,
  dispatchResetGstError,
  dispatchResetGstOtpError,
  fetching,
  gstOtpMessage,
  dispatchVerifyGstOtp,
  error,
  message,
  gstOtpVerifyMessage,
  gstOtpVerifyError,
  gstOtpVerifyStatusCode,
  dispatchResetGstOtpMessage,
  gstOtpFetching,
  dispatchResetGstOtpVerifyError,
  dispatchResetGstOtpVerifyMessage,
  history,
  dispatchResetGstOtpFetching,
  dispatchResetGstOtpVerifyFetching,
  dispatchResetGstOtpRequestFetching,
  gstOtpVerifyFetching,
  gstOtpRequestFetching,
}: AppProps) => {
  const [onCancel, setOnCancel] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(1);
  const [otpData, setOtpData] = useState<OtpDataType>({
    client_code: clientCode,
    gst_username: "",
    gst_number: "",
  });
  const [receivedOTP, setReceived] = useState("");
  const [isOTPSent, setIsOtpSent] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const [verifyAlertMessage, setVerifyAlertMessage] = useState("");

  useEffect(() => {
    if (gstOtpVerifyMessage === "OTP Verified Successfully!") {
      let countdown = 3;
      setVerifyAlertMessage(
        `${gstOtpVerifyMessage} Closing pop-up in ${countdown}`
      );

      const timer = setInterval(() => {
        countdown -= 1;
        if (countdown > 0) {
          setVerifyAlertMessage(
            `${gstOtpVerifyMessage} Closing pop-up in ${countdown}`
          );
        } else {
          clearInterval(timer);
          dispatchResetGstError();
          setOnCancel(false);
        }
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [gstOtpVerifyMessage]);
  useEffect(() => {
    dispatchResetGstOtpFetching();
    dispatchResetGstOtpVerifyFetching();
    dispatchResetGstOtpRequestFetching();
    dispatchResetGstOtpError();
    dispatchResetGstOtpMessage();
    dispatchResetGstOtpVerifyError();
    dispatchResetGstOtpVerifyMessage();
    if (gstDetails?.legalName) {
      setOtpData({
        client_code: clientCode,
        gst_username: gstDetails?.gstUsername,
        gst_number: gstDetails?.gstIn,
      });
    }
  }, [gstDetails]);

  useEffect(() => {
    let interval: any = null;

    if (isActive && minutes >= 0) {
      interval = setInterval(() => {
        setSeconds(() => seconds - 1);
        if (seconds === 0) {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
        if (minutes === 0 && seconds === 0) {
          setIsActive(false);
          setSeconds(0);
          setMinutes(0);
        }
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  });

  useEffect(() => {
    if (gstOtpMessage === "OTP Sent Successfully!") {
      setIsOtpSent(true);
      dispatchResetGstOtpError();
      setIsActive(true);
    }
  }, [gstOtpMessage]);

  useEffect(() => {
    if (gstOtpMessage === "OTP Sent Successfully!") {
      setShowAlert(true);

      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      setShowAlert(false);
    }
  }, [gstOtpMessage]);

  const handleValidateOtp = () => {
    let finalData = {
      token,
      gst_number: gstDetails?.gstIn,
      client_code: clientCode,
      gst_username: otpData?.gst_username,
      otp: receivedOTP,
    };
    dispatchVerifyGstOtp(finalData);
  };

  const handleSendOtp = () => {
    let finalData = {
      client_code: clientCode,
      gst_username: otpData?.gst_username,
      gst_number: gstDetails?.gstIn,
      token,
    };
    dispatchRequestGstOtp(finalData);
  };

  const handleSetData = (e: any) => {
    setOtpData((prev: any) => {
      return {
        ...prev,

        [e.target.name]: e.target.value,
      };
    });
  };

  return (
    <>
      <Modal isOpen={onCancel} toggle={() => setOnCancel(true)} size="lg">
        <ModalHeader
          {...(gstOtpVerifyMessage !== "OTP Verified Successfully!" && {
            toggle: () => {
              setOnCancel(!onCancel);
              dispatchResetGstError();
              dispatchResetGstOtpError();
              dispatchResetGstOtpMessage();
            },
          })}
          className="pt-4 pl-4"
        >
          Validate GST
        </ModalHeader>

        <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
          <div className="top-heading">
            Enter GST Username to validate with OTP.
          </div>
          <div className="mt-2">
            <div style={{ width: "100%", paddingTop: "20px" }}>
              <div
                style={{
                  backgroundColor: "#fef2ed",
                  color: "#ba4916",
                  border: "1px solid #ba4916",
                  padding: "10px",
                }}
              >
                <div>
                  It is mandatory to enable API access from the GST Portal.
                  Follow the steps by clicking on the link, if not done already.
                  Click Here{" "}
                  <Button
                    color="link"
                    className="p-0"
                    style={{ fontSize: "12px" }}
                    onClick={() => window.open("/gstr-steps", "_blank")}
                  >
                    View GSTR Steps
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group mt-3">
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="stockGroupName">
                  GST Username <span className="color-red">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="gst_username"
                  value={otpData?.gst_username}
                  maxLength={150}
                  required
                  onChange={handleSetData}
                  disabled={
                    gstOtpVerifyMessage === "OTP Verified Successfully!"
                  }
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="stockGroupName">GST Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="gst_number"
                  value={otpData?.gst_number}
                  maxLength={15}
                  required
                  disabled
                />
                <span className="input-length">
                  {returnInputFieldLength(otpData?.gst_number?.length, 15)}
                </span>
              </div>
              <div className="col-md-4 d-flex justify-containt-start align-items-center">
                <div>
                  <Button
                    color="primary ml-3 "
                    className={
                      isActive || (seconds === 0 && minutes === 0 && !isActive)
                        ? `mt-4`
                        : `mt-2`
                    }
                    style={{ height: "38px" }}
                    onClick={(e: any) => {
                      handleSendOtp();
                    }}
                    disabled={
                      fetching ||
                      isOTPSent ||
                      (otpData?.gst_username?.trim()?.length ?? 0) === 0
                    }
                  >
                    {gstOtpRequestFetching ? "Sending OTP..." : "Send OTP"}
                  </Button>
                  {isActive && (
                    <div className="input-length ml-3 mt-3">
                      Resend OTP in {minutes <= 9 ? "0" : ""}
                      {minutes}:{seconds <= 9 ? "0" : ""}
                      {seconds}
                    </div>
                  )}
                  {seconds === 0 && minutes === 0 && !isActive ? (
                    <div className="ml-3 mt-3">
                      <span className="mr-3">Didn’t receive OTP?</span>
                      <span
                        style={{ color: "#dd4433", cursor: "pointer" }}
                        onClick={(e: any) => {
                          setMinutes(1);
                          dispatchResetGstOtpError();
                          dispatchResetGstOtpMessage();
                          handleSendOtp();
                        }}
                      >
                        {" "}
                        Resend
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="row ml-1">
              <h4>GST Details</h4>
            </div>
            <div className="row ml-1">
              <div className="col-md-4 p-1">
                <label
                  className="mb-1 subHeadingTeamDetailLabel"
                  htmlFor="Stage"
                >
                  Legal Name
                </label>
                <p>{gstDetails?.legalName}</p>
              </div>
              <div className="col-md-4 pt-1 pb-1">
                <label
                  className="mb-1 subHeadingTeamDetailLabel"
                  htmlFor="Stage"
                >
                  Trade Name
                </label>
                <p>{gstDetails?.tradeName}</p>
              </div>
              <div className="col-md-4 pt-1 pb-1">
                <label
                  className="mb-1 subHeadingTeamDetailLabel"
                  htmlFor="Stage"
                >
                  Registration Type
                </label>
                <p style={{ overflowWrap: "anywhere" }}>
                  {gstDetails?.registrationType
                    ? gstDetails?.registrationType
                    : "NA"}
                </p>
              </div>
            </div>
          </div>

          {/* ///// */}
          <div>
            <div className="row ml-1">
              <div className="col-md-4 p-1">
                <label
                  className="mb-1 subHeadingTeamDetailLabel"
                  htmlFor="Stage"
                >
                  Registration Date
                </label>
                <p>
                  {gstDetails?.registrationDate
                    ? gstDetails?.registrationDate
                    : "NA"}
                </p>
              </div>
              <div className="col-md-4 pt-1 pb-1">
                <label
                  className="mb-1 subHeadingTeamDetailLabel"
                  htmlFor="Stage"
                >
                  Constitution of Business
                </label>
                <p>
                  {gstDetails?.constitutionOfBusiness
                    ? gstDetails?.constitutionOfBusiness
                    : "NA"}
                </p>
              </div>
              <div className="col-md-4 pt-1 pb-1">
                <label
                  className="mb-1 subHeadingTeamDetailLabel"
                  htmlFor="Stage"
                >
                  Company Status
                </label>
                <p style={{ overflowWrap: "anywhere" }}>
                  {gstDetails?.companyStatus ? gstDetails?.companyStatus : "NA"}
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <label htmlFor="stockGroupName">Enter OTP</label>
              <input
                type="text"
                className={`form-control`}
                name="otp"
                value={receivedOTP}
                maxLength={6}
                required
                disabled={
                  !isOTPSent ||
                  gstOtpVerifyMessage === "OTP Verified Successfully!"
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // only numeric input
                    setReceived(value);
                  }
                }}
              />
              {returnInputFieldLength(receivedOTP?.length, 6)}
            </div>
            <div className="col-md-4 d-flex justify-containt-start align-items-center">
              <button
                style={{ height: "38px" }}
                className="btn btn-outline mt-1"
                disabled={
                  receivedOTP?.length < 6 ||
                  gstOtpVerifyMessage === "OTP Verified Successfully!"
                }
                onClick={() => {
                  handleValidateOtp();
                }}
              >
                {gstOtpVerifyFetching ? "Validating OTP..." : "Validate OTP"}
              </button>
            </div>
          </div>
          {gstOtpError?.length && (
            <>
              <div
                className="alerts"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <img width={"24px"} src={Warning} alt="warning" />
                {gstOtpError}
                {gstOtpError ===
                  "OTP generation failed as OTP server is down. Contact Support" && (
                  <Button
                    color="link"
                    className="p-0"
                    style={{ fontSize: "12px" }}
                    onClick={() => window.open("/support", "_blank")}
                  >
                    Click here
                  </Button>
                )}
              </div>
            </>
          )}
          {gstOtpVerifyError?.length && (
            <div
              className="alerts"
              style={{
                display: "flex",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <img width={"24px"} src={Warning} alt="warning" />
              {gstOtpVerifyError}

              {gstOtpVerifyError ===
                "OTP generation failed as OTP server is down. Contact Support" && (
                <Button
                  color="link"
                  className="p-0"
                  style={{ fontSize: "12px" }}
                  onClick={() => window.open("/support", "_blank")}
                >
                  Click here
                </Button>
              )}
            </div>
          )}

          {showAlert && (
            <div
              className="success-alert"
              style={{
                display: "flex",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              {gstOtpMessage}
            </div>
          )}

          {gstOtpVerifyMessage && (
            <div
              className="success-alert"
              style={{
                display: "flex",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              {verifyAlertMessage}
            </div>
          )}
        </ModalBody>
      </Modal>

      {gstOtpFetching && <Loader />}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  gstOtpError: state.gst.gstOtpError,
  gstOtpMessage: state.gst.gstOtpMessage,
  fetching: state.gst.fetching,
  message: state.gst.message,
  error: state.gst.error,
  gstOtpVerifyMessage: state.gst.gstOtpVerifyMessage,
  gstOtpVerifyError: state.gst.gstOtpVerifyError,
  gstOtpVerifyStatusCode: state.gst.gstOtpVerifyStatusCode,
  gstOtpFetching: state.gst.gstOtpFetching,
  gstOtpVerifyFetching: state.gst.gstOtpVerifyFetching,
  gstOtpRequestFetching: state.gst.gstOtpRequestFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchRequestGstOtp: (data: RequestGstOtpPayloadType) =>
    dispatch(requestGstOtpAction(data)),
  dispatchResetGstError: () => dispatch(resetGstModuleError()),
  dispatchResetGstOtpError: () => dispatch(resetGstOtpError()),
  dispatchVerifyGstOtp: (data: VerifyGstOtpPayloadType) =>
    dispatch(verifyGstOtpAction(data)),
  dispatchResetGstOtpMessage: () => dispatch(resetGstOtpMessage()),
  dispatchResetGstOtpVerifyError: () => dispatch(resetGstOtpVerifyError()),
  dispatchResetGstOtpVerifyMessage: () => dispatch(resetGstOtpVerifyMessage()),
  dispatchResetGstOtpFetching: () => dispatch(resetGstOtpFetching()),
  dispatchResetGstOtpVerifyFetching: () =>
    dispatch(resetGstOtpVerifyFetching()),
  dispatchResetGstOtpRequestFetching: () =>
    dispatch(resetGstOtpRequestFetching()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidateGST);
